import { fileUploading } from "./fileUploading/ka";
import { piForm } from "./PIForm/ka";
import { loanApplication } from "./loanApplication/ka";

export const TRANSLATION_KA = {
  ...fileUploading,
  ...piForm,
  ...loanApplication,
};
